import { render, staticRenderFns } from "./ProductModals.vue?vue&type=template&id=0d79472b&scoped=true&"
import script from "./ProductModals.vue?vue&type=script&lang=js&"
export * from "./ProductModals.vue?vue&type=script&lang=js&"
import style0 from "./ProductModals.vue?vue&type=style&index=0&id=0d79472b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d79472b",
  null
  
)

export default component.exports